<template>
    <div class="TextAreaExpandable">
        <textarea
            ref="textareaexp"
            :name="Name"
            class="form-control"
            v-bind:class="Class"
            :placeholder="Placeholder"
            v-bind:required="Required"
            v-model="value"
            v-bind:style="{height: ElementHeight + 'px', overflow: MaxHeight == null ? 'hidden' : 'auto'}" 
            @input="updateInput()">
        </textarea>
    </div>

</template>

<script>
    

    export default {
        props: [
            "Class",
            "BaseHeight",
            "MaxHeight",
            "Placeholder",
            "Required",
            "Name",
            "value"
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            updateInput() {
                this.$emit('input', this.$refs.textareaexp.value)
            }
        },
        components: {

        },
        computed: {
            ElementHeight: function () {
                if (this.value != "" && this.$refs.hasOwnProperty("textareaexp")) {

                    let scrollHeight = this.$refs['textareaexp'].scrollHeight;
                    //let initRows = (this.Content.match(/\n/g) || []).length + 1;
                    if (scrollHeight >= this.BaseHeight) {
                        if (this.MaxHeight != null && scrollHeight >= this.MaxHeight) {
                            return this.MaxHeight;
                        } else {
                            return scrollHeight;
                        }
                    } else {
                        return this.BaseHeight;
                    }
                } else {
                    return this.BaseHeight;
                }            
            }
        },
        
    }
</script>

<style scoped>

</style>